/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import i18n from '@fai/friendli-suite/features/i18n';
import Paths from '@fai/friendli-suite/features/routes/paths';
import { useFlags } from '@fai/friendli-suite/shared/launch-darkly';

export const useProductDetailLinksWithLabel = ({
  teamId,
  projectId,
}: {
  teamId: string;
  projectId: string;
}) => {
  const { dedicatedEndpointsRag, dedicatedEndpointsMonthlyUsage } = useFlags();

  return [
    {
      label: i18n.t('dedicated_endpoints.layout.endpoints'),
      path: Paths.team(teamId).dedicatedEndpoints.project.detail(projectId).endpoint.default,
    },
    {
      label: i18n.t('dedicated_endpoints.layout.finetuning'),
      path: Paths.team(teamId).dedicatedEndpoints.project.detail(projectId).finetuning.default,
    },
    {
      label: i18n.t('dedicated_endpoints.layout.models'),
      path: Paths.team(teamId).dedicatedEndpoints.project.detail(projectId).model.default,
    },
    {
      label: i18n.t('dedicated_endpoints.layout.datasets'),
      path: Paths.team(teamId).dedicatedEndpoints.project.detail(projectId).dataset.default,
    },
    ...(dedicatedEndpointsRag
      ? [
          {
            label: i18n.t('dedicated_endpoints.layout.documents'),
            path: Paths.team(teamId).dedicatedEndpoints.project.detail(projectId).document.default,
          },
        ]
      : []),
    ...(dedicatedEndpointsMonthlyUsage
      ? [
          {
            label: i18n.t('dedicated_endpoints.layout.usage'),
            path: Paths.team(teamId).dedicatedEndpoints.project.detail(projectId).monthlyUsage,
          },
        ]
      : []),
    {
      label: i18n.t('dedicated_endpoints.layout.project_settings'),
      path: Paths.team(teamId).dedicatedEndpoints.project.detail(projectId).settings,
    },
  ];
};
